__webpack_require__.p = "https://testcdn.ajinga.com/v-uat/";